import axios from '@services/axios'
export * from './interface'

interface IGlobalProps {
  pageId: string
  sid?: string
}
const prefix = '/learn/app/'
export default {
  /** 增值服务 */
  queryVasOperation2NativeList(): Promise<any> {
    return axios.get(`${prefix}clientapi/misc/queryVasOperation2NativeList.do`)
  },
  queryHomeGlobalInfo(pageId: string): Promise<any> {
    return axios.get(
      `${prefix}clientapi/home/pc/queryHomeGlobalInfo.do?pageId=${pageId}`
    )
  },
  queryHomeChannelModule(pageId: string): Promise<any> {
    return axios.get(
      `${prefix}clientapi/home/pc/queryHomeChannelModule.do?pageId=${pageId}`
    )
  },
  othersPersonDetail(searchedUserId: string) {
    return axios.get(`${prefix}othersPersonDetail.do`, {
      params: {
        searchedUserId,
      },
    })
  },
  /**
   * 获取飘窗信息
   */
  getRollWindowInfo: (props: IGlobalProps) => {
    return axios.get(`${prefix}clientapi/home/pc/getRollWindowInfo.do`, {
      params: {
        ...props,
      },
    })
  },
}
